/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 */
import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import nlLocaleData from 'react-intl/locale-data/nl';

import enTranslationMessages from './translations/en.json';
import nlTranslationMessages from './translations/nl.json';

addLocaleData(enLocaleData);
addLocaleData(nlLocaleData);

const DEFAULT_LOCALE = 'en';

// prettier-ignore
export const appLocales = [
  'en',
  'nl',
];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale === DEFAULT_LOCALE
      ? {}
      : formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages);
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  nl: formatTranslationMessages('nl', nlTranslationMessages),
};

export { DEFAULT_LOCALE };
